import { stateEnum, eventTypeEnum } from '@/constants'

export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
)

/**
 * @param {FormData} formData
 * @returns {Object}
 */
export function formDataToObject(formData) {
  const formDataObj = {}
  formData.forEach((value, key) => (formDataObj[key] = value))
  return formDataObj
}
/**
 * @param {object} object
 * @returns {FormData}
 */
export function objectToFormData(object) {
  const fd = new FormData()
  for (const key in object) {
    fd.append(key, object[key])
  }
  return fd
}

/**
 * @param {Scheme} scheme
 * @param {SegmentDetail} payload
 */
export function mergeSchemeWithPayload(scheme, payload) {
  for (const key in scheme) {
    scheme[key].value = payload[key]
  }
}

/**
 * @param {RequestStateMethods} state
 * @returns {string}
 */
export const getStateName = (state) => {
  return stateEnum[state] || state
}

/**
 * @param {string} eventType
 * @returns {string}
 */
export const getEventTypeName = (eventType) => {
  return eventTypeEnum[eventType] || eventType
}

/**
 * @param {Date} date
 * @returns {string}
 */
export const getLocalDate = (date) => {
  return new Date(date).toLocaleDateString('ru')
}

export const formatDate = (dateString) => {
  const date = new Date(dateString)

  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * Return full path url
 * Локально, может работать не корректно
 * @param {string} url
 * @returns {string}
 */
export const mediaUrl = (url) => {
  if (!url) return ''
  if (url.startsWith('data:')) return url
  if (!url.startsWith('/media/')) url = '/media/' + url
  return process.env.VUE_APP_MEDIA_URL + url
}

/**
 * Мутирует передаваемый обьект удаляя все "пустые" свойтва.
 * Удаляет [[ null, undefined, '' ]]
 * Удобно использовать для необязательных query параметров, когда пустые значения не должны передаваться в запрос
 * @param {object} obj
 * @param {string[]} forceRemove
 */
export const removeEmpty = (obj, forceRemove = ['default']) => {
  var value, key
  for (key in obj) {
    value = obj[key]
    if (value == null || value === '' || forceRemove.includes(value))
      delete obj[key]
  }
}

/**
 * @param {function} fn
 * @param {number} ms
 * @return {function} debounced fn
 */
export const debounce = (fn, ms) => {
  var timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(fn, ms, ...args)
  }
}

export const getStorage = (key) => {
  return JSON.parse(localStorage.getItem(key))
}

export const setStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const removeStorage = (key) => {
  localStorage.removeItem(key)
}

export const getTimestamp = () => {
  return Date.now()
}

/**
 * Преобразует Data URI в Blob для создания File объекта
 * @param {string} dataURI - Data URI строка (например, из FileReader.readAsDataURL)
 * @returns {Blob} - Blob объект, который можно использовать для создания File
 */
export const dataURItoBlob = (dataURI) => {
  try {
    const byteString = atob(dataURI.split(',')[1])
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    return new Blob([ab], { type: mimeString })
  } catch (error) {
    console.error('Ошибка при конвертации Data URI в Blob:', error)
    return new Blob([], { type: 'application/octet-stream' })
  }
}

export function isNumber(value) {
  return typeof value === 'number' && !isNaN(value)
}

/**
 * В Safari не корректно работает 3D-преобразование,
 * поэтому отключаем перспективу
 * https://red.w-not.ru/issues/4113
 */
export const defaultPerspective = isSafari ? 'none' : 1000

/**
 * Генерация UUID
 * @returns string
 */
export function generateUUID() {
  return crypto.randomUUID()
}

/**
 * Возвращает правильное слово в зависимости от числа
 * @param {number} number - число
 * @param {[string, string, string]} words - варианты слова: ['яблоко', 'яблока', 'яблок']
 * @returns {string} строка с правильным словом
 */
/**
 * Нормализует данные фотопривязки, преобразуя вложенную структуру в плоскую,
 * подходящую для использования в компоненте Transform.
 * @param {object} photobind - Объект фотопривязки из API.
 * @returns {object} Нормализованный объект.
 */
export const normalizePhotobindData = (photobind) => {
  const mapped = {
    ...photobind,
    ...(photobind.data || {}),
    id: photobind.id,
    banner_id: photobind.banner?.id,
    image: photobind.banner?.image,
  }
  delete mapped.data
  delete mapped.banner
  return mapped
}

export function pluralize(number, words) {
  number = Math.abs(number) % 100
  const n1 = number % 10

  if (number > 10 && number < 20) return words[2]
  if (n1 > 1 && n1 < 5) return words[1]
  if (n1 === 1) return words[0]
  return words[2]
}
